import { render, staticRenderFns } from "./EnterprisePlanSelectionPage.vue?vue&type=template&id=edc99d60&scoped=true&"
import script from "./EnterprisePlanSelectionPage.vue?vue&type=script&lang=ts&"
export * from "./EnterprisePlanSelectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc99d60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
